import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import { WorkflowAutomation } from '@recruitee/workflow-automations-types';

const idSelector = ({ id }: { id: number }) => id;
const { actions, namespace, reducer, selectors } = createEntityCollectionStore<{
  id: number;
  workflowAutomations: WorkflowAutomation[];
}>()('PipelineTemplateStageAutomations', {
  customActions: adapter => {
    const defaultActions = getEntityCollectionActions(adapter, idSelector);

    return {
      fetchStages: (state, payload: { pipelineTemplateId: number }) => adapter.markAsPending(state),
      fetchStagesSuccess: defaultActions.fetchCollectionSuccess,
      fetchStagesFailed: defaultActions.fetchCollectionFailed,
    };
  },
});

const PipelineTemplateStageAutomationsActions: PickActions<typeof actions, 'fetchStages'> = actions;

export {
  PipelineTemplateStageAutomationsActions,
  namespace as PipelineTemplateStageAutomationsNamespace,
  reducer as PipelineTemplateStageAutomationsReducer,
  selectors as PipelineTemplateStageAutomationsSelectors,
};
